import gameLang from './lang/game';
import addLang from './lang/add';
import subscribeLang from './lang/subscribe';
import settingLang from './lang/setting';
import commonLang from './lang/common';

const getLang = (obj, prefix) => {
  let tempObj = {};
  Object.keys(obj).forEach(key => {
    if (prefix) {
      tempObj = Object.assign(tempObj, { [`${prefix}_${key}`]: obj[key][0] });
    } else {
      tempObj = Object.assign(tempObj, { [key]: obj[key][0] });
    }
  });
  return tempObj;
};

const en_US_app = {
  MENU_GAME: '平台',
  MENU_SUBSCRIBE: '常见问题',
  MENU_SETTING: '视频',
  ...getLang(gameLang, 'game'),
  ...getLang(addLang, 'add'),
  ...getLang(subscribeLang, 'subscribe'),
  ...getLang(settingLang, 'setting'),
  ...getLang(commonLang, 'common'),
  //... ...
};
export default en_US_app;
